import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

// project imports
import { useInterviewContext } from "../../context/interview_context";
import { useProductContext } from "../../context/product_context";
import ToolTip from "../../common/Tooltip/ToolTip";
import { FREE, PAID } from "../../constants";
import BannerSixStencil from "./BannerSixStencil";
import { GoogleAnalyticsEnum, triggerFunction } from "../../utils/google-analytics";

// Reading Variables from env - start
const TYPE_DEVELOPER = process.env.REACT_APP_OFFERING_TYPE_DEVELOPER;
const TYPE_ADMIN = process.env.REACT_APP_OFFERING_TYPE_ADMIN;
// Reading Variables from env - end

export default function BannerSix({ stencilLoading }) {
    // Extracting variables from context
    const { interviewCategories } = useInterviewContext();
    const { ebooks, products, searchTerm } = useProductContext();

    // navigate
    const navigate = useNavigate();

    // Constants variables
    const ebooksLabel = ebooks && ebooks?.length ? ebooks?.map((i) => i?.name) : [];
    const filteredTrainingPrograms = products && products?.length ? products?.filter((i) => i?.name && i?.type === "internship") : [];
    const trainingsProgramsLabel = filteredTrainingPrograms && filteredTrainingPrograms?.length ? filteredTrainingPrograms?.map((i) => i?.name) : [];
    const filteredFlexibleLeariningLabel = products && products?.length ? products?.filter((i) => i?.name && i?.type === "flex-learning-path") : [];
    const flexibleLeariningLabel = filteredFlexibleLeariningLabel && filteredFlexibleLeariningLabel?.length ? filteredFlexibleLeariningLabel?.map((i) => i?.name) : [];
    const interviewCategoriesLabel = interviewCategories && interviewCategories?.length ? interviewCategories?.map((i) => (i?.name || "")) : [];

    // check all free Ebooks
    const freeEBooks = ((ebooks && ebooks.length) || searchTerm ? ebooks?.filter((item) => item?.pricing.price <= 0 || (item?.discount?.hasDiscount && item?.discount?.discountPercent === 100)) : ebooks?.filter((item) => item?.pricing.price <= 0 || (item?.discount?.hasDiscount && item?.discount?.discountPercent === 100))) || [];

    // check All trainingProgram of salesforce Admin
    const trainingProgramAdmin = (products || [])?.filter(
        (item) =>
            item?.category === "salesforce" && item?.subCategory === "administration" && item?.type === "internship"
    );

    // check All flexibleLearningPath of salesforce Admin
    const flexibleLearningPathAdmin = products?.filter(
        (item) =>
            item?.category === "salesforce" && item?.subCategory === "administration" && item?.type === "flex-learning-path"
    );

    const category = [
        { key: "e-books", label: "E-Books", value: "our-resources" },
        { key: "training-programs", label: "Training Programs", value: "our-offerings" },
        { key: "interview-questions", label: "Interview Q&A", value: "interview-questions" },
        { key: "flex-learning-path", label: "Flexible Learning Path", value: "flex-learning-path" }
    ];

    const subCategory = [
        { label: ebooksLabel, value: "E-Books" },
        { label: trainingsProgramsLabel, value: "Training Programs" },
        { label: interviewCategoriesLabel, value: "Interview Q&A" },
        { label: flexibleLeariningLabel, value: "Flexible Learning Path" }

    ]

    // State initalization
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [selectedSubCategory, setSelectedSubCategory] = useState("");

    //  Initialize an empty Map
    const ebookMap = new Map();
    (ebooks || [])?.forEach(item => {
        ebookMap.set(item?.name, item?.productCode);
    });

    //  Initialize an empty Map
    const trainingProgramsMap = new Map();
    (products || [])?.forEach(item => {
        trainingProgramsMap.set(item?.name, item?.productCode);
    });

    //  Initialize an empty Map
    const interviewQuestionsMap = new Map();
    (interviewCategories || [])?.forEach(item => {
        interviewQuestionsMap.set(item?.name, item?.slug);
    });

    // merged All MapData
    const mapData = new Map([...ebookMap, ...trainingProgramsMap, ...interviewQuestionsMap])

    // Find the subcategory list by matching category label with subcategory value
    const matchedSubCategoryData = subCategory?.find(
        (sub) => sub?.value === selectedCategory?.label
    );

    // Subcategories
    const currentSubCategoryList = matchedSubCategoryData ? matchedSubCategoryData?.label : [];

    // handle function for Category
    const handleCategory = (catObj) => {
        try {
            if (selectedCategory?.key === catObj?.key) {
                setSelectedCategory(null);
                setSelectedSubCategory("");
                return;
            }
            setSelectedCategory(catObj);
            setSelectedSubCategory(""); // Clear child choice on parent change
        } catch (error) {
            console.log("107 : BannerSix : Error while handleCategory", error);
        }
    };

    // handle function for subcategory
    const handleSubCategory = (subItem) => {
        try {
            setSelectedSubCategory(subItem);
        } catch (error) {
            console.log("116 : BannerSix : Error while handleSubCategory", error);
        }
    }

    const handleSubmit = (e) => {
        e.preventDefault();

        try {
            if (!selectedCategory || !selectedSubCategory) {
                return;
            }

            const selectedFreeEBook = freeEBooks?.some(i => i?.name === selectedSubCategory);
            const ebookCode = selectedFreeEBook ? FREE : PAID;

            const selectedTrainingProgram = trainingProgramAdmin?.some(i => i?.name === selectedSubCategory);
            const trainingProgramCode = selectedTrainingProgram ? TYPE_ADMIN : TYPE_DEVELOPER;

            const selectedFlexibleLearning = flexibleLearningPathAdmin?.some(i => i?.name === selectedSubCategory);
            const flexibleLearningCode = selectedFlexibleLearning ? TYPE_ADMIN : TYPE_DEVELOPER;

            //  Find the parent object that contains the selected label string
            const matchedItemSlug = (mapData?.get(selectedSubCategory)).toLowerCase();

            let finalUrl = "";
            switch (selectedCategory.key) {
                case "e-books":
                    finalUrl = `/our-resources/${ebookCode}/${matchedItemSlug}`;
                    break;

                case "training-programs":
                    finalUrl = `/our-offerings/${trainingProgramCode}/${matchedItemSlug}`;
                    break;

                case "interview-questions":
                    finalUrl = `/interview-questions/${matchedItemSlug}`;
                    break;

                case "flex-learning-path":
                    finalUrl = `/our-offerings/${flexibleLearningCode}/${matchedItemSlug}`;
                    break;

                default:
                    return;
            }
            navigate(finalUrl);
            triggerFunction(
                GoogleAnalyticsEnum.BUTTON,
                `SEARCH_CATEGORY_${selectedCategory?.label?.toUpperCase()}_SUBCATEGORY_${selectedSubCategory.toUpperCase()}`
            )
        } catch (error) {
            console.log("167 : BannerSix : Error while handleSubmit", error);

        }
    };

    if (stencilLoading) {
        return <BannerSixStencil />;
    }

    return (
        <section className="masthead -type-7 js-mouse-move-container">
            <div className="masthead__bg bg-color-primary rounded-5">
                <div className="container">
                    <div className="row justify-content-between align-items-center">

                        <div
                            className="col-12 col-xl-7 col-lg-6"
                            data-aos="fade-up"
                            data-aos-delay="500"
                        >
                            <div className="masthead__content">

                                <h1 className="masthead__title text-white is-in-view">
                                    Learn Salesforce the Way It’s Actually Used
                                </h1>

                                <p className="masthead__text fs-15 text-white lh-2 pt-10 is-in-view">
                                    Get practical Salesforce training focused on real-world development, administration, integrations, and projects.
                                </p>

                                <div>
                                    <div className="masthead-form bg-white rounded-5 mt-30 p-3">
                                        <form
                                            onSubmit={handleSubmit}
                                            className="d-flex align-items-center flex-wrap"
                                        >

                                            <div className="masthead-form__item">
                                                <div className="dropdown js-dropdown w-1/1 bg-white">
                                                    <div className="d-flex align-items-center justify-content-between">
                                                        <span className="js-dropdown-title truncate-custom">
                                                            {selectedCategory ? selectedCategory?.label : "Category"}
                                                        </span>
                                                        <i className="icon-arrow-down-s-line"></i>
                                                    </div>
                                                    <div className="dropdown__item shadow-1">
                                                        <div className="y-gap-15 js-dropdown-list">
                                                            {category.map((catObj) => (
                                                                <div key={catObj?.key}>
                                                                    <span
                                                                        onClick={() => handleCategory(catObj)}
                                                                        className={`d-block js-dropdown-link cursor ${selectedCategory?.key === catObj.key ? "active" : ""}`}
                                                                    >
                                                                        {catObj?.label || ""}
                                                                    </span>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>


                                            <div className="masthead-form__item">
                                                <div className={`dropdown js-dropdown w-1/1 bg-white ${!selectedCategory ? "cursor-initial" : ""}`}>
                                                    <div className="d-flex align-items-center justify-content-between">
                                                        <span className="js-dropdown-title truncate-custom">
                                                            {selectedSubCategory
                                                                ? selectedSubCategory
                                                                : selectedCategory ? "Subcategory" : "Subcategory"}
                                                        </span>
                                                        <i className="icon-arrow-down-s-line"></i>
                                                    </div>

                                                    {selectedCategory && currentSubCategoryList?.length > 0 && (
                                                        <div className="dropdown__item shadow-1">
                                                            <div className="y-gap-15 js-dropdown-list">
                                                                {currentSubCategoryList?.map((subItem, i) => (
                                                                    <div key={i}>
                                                                        <ToolTip title={subItem} placement="auto">
                                                                            <span
                                                                                onClick={() => handleSubCategory(subItem)}
                                                                                className={`d-block truncate-dropdown__item js-dropdown-link cursor ${selectedSubCategory === subItem ? "active" : ""}`}
                                                                            >
                                                                                {subItem || ""}
                                                                            </span>
                                                                        </ToolTip>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>

                                            <div className="masthead-form__button btn-primary">
                                                <button
                                                    className={`edu-btn btn-secondary text-white ${!selectedCategory || !selectedSubCategory ? "cursor-initial" : ""}`}
                                                >
                                                    Search
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div
                            className="col-xl-5 col-lg-6"
                            data-aos="fade-up"
                            data-aos-delay="750"
                        >
                            <div className="masthead-image">
                                <div className="masthead-image__img1">
                                    <img
                                        data-move="20"
                                        className="js-mouse-move"
                                        src="/images/banner/banner-01/video-image.png"
                                        alt="#"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}